import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Route, Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Toolbar from "@material-ui/core/Toolbar";
import AppBar from "@material-ui/core/AppBar";
import Grid from "@material-ui/core/Grid";
import styled from "styled-components";
import _ from 'lodash';

import { FormControl, Select, MenuItem } from "@material-ui/core";
import { isEmpty } from "lodash";
import {
  fetchAllFunds,
  fetchFunds,
  fetchFundDeals,
  getFundInfo,
  createFund,
  getFundMetrics
} from "store/state/fund";
import { openNotes } from "store/state/note";
import { ROUTE_FUNDS_EDIT } from "constants/routes";
import PrivateRoute from "components/PrivateRoute";
// Icons
import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted";
import ViewModuleIcon from "@material-ui/icons/ViewModule";
import EditIcon from "lib/ui/edit";
import DownloadIcon from "lib/ui/download";
import ClockIcon from "lib/ui/clock";
import FileIcon from "lib/ui/file";
import FundEditModal from "components/Fund/Edit";
import { CLOSED, SOLD, REFINANCE, ADDING_SUPPLEMENTAL, MODIFYING } from "constants/status";

import { default as SoldDealViewTableColumns } from "components/Global/TablePreferenceColumns/DealTableColumns/SoldDealViewTableColumns";
import { default as ClosedDealTableColumns } from "components/Global/TablePreferenceColumns/DealTableColumns/ClosedDealTableColumns";

import DealList from "./DealList";
import DealTiles from "./DealTiles";
import Styles from "./styles";

// Consts

//Widget Tiles
import MetricTile from "components/Global/Metric/MetricTile";
import { getScreenPreferences } from "../../../shared-utility/store/state/screenPreferences";
import ScrollableTabButtons from "./ScrollableTabButtons";

const sold_deal_tableScreenType = "sold_deal_table";
const closed_deal_tableScreenType = "closed_deal_table";

const screenType = "fund_view_metric";
const MetricPaddedDiv = styled.div`
  padding: 40px 16px 0 16px;
`;

const PaddedDiv = styled.div`
  padding-top:25px;
  margin-left:56px;
  margin-right:56px;
`;
class FundDealsList extends React.Component {
  state = {
    view: "list"
  };
  
  componentDidMount() {
    const {
      match: {
        params: { fundId }
      }
    } = this.props;        
    this.props.getFundMetrics({ fundId: fundId });
    this.props.fetchFunds();
    this.props.fetchAllFunds();
    this.props.getFundInfo({ fundId: fundId });
    this.props.getScreenPreferences({
      screenType
    });
    this.props.getScreenPreferences({
      screenType: sold_deal_tableScreenType
    });
    this.props.getScreenPreferences({
      screenType: closed_deal_tableScreenType
    });
  }
  onFundEdit = () => {
    this.props.fetchFunds();
  };
  componentDidUpdate(prevProps, prevState) {
    const {
      match: {
        params: { fundId: prevFundId }
      }
    } = prevProps;
    const {
      match: {
        params: { fundId }
      }
    } = this.props;
    if (prevFundId !== fundId) {
      this.props.getFundInfo({ fundId: fundId });
      this.props.getFundMetrics({ fundId: fundId });
    }
  }

  listView = () => {
    this.setState({ view: "list" });
  };

  tileView = () => {
    this.setState({ view: "tile" });
  };

  navigateToFund = fundId => {
    if (fundId !== "none") {
      this.props.history.push(`/portfolio/funds/${fundId}`);
    } else {
      this.props.history.push(`/portfolio`);
    }
  };

  columns = [
    {
      id: "image",
      numeric: false,
      label: ""
    },
    {
      id: "fund",
      numeric: false,
      label: "Group"
    },
    {
      id: "ltv",
      numeric: false,
      label: "LTV"
    },
    {
      id: "dscr",
      numeric: false,
      label: "DSCR"
    },
    {
      id: "prepaymentPenalty",
      numeric: false,
      label: "Prepayment Penalty"
    },
    /*
    {
      id: "metrics",
      numeric: true,
      label: "Metrics"
    },
    */
    {
      id: "actions",
      numeric: false,
      label: "Actions",
      actions: true
    }
  ];

  handleEdit = () => {
    const { history, location } = this.props;
    history.push(`${location.pathname}/edit`);
  };

  createFund = values => {
    this.props.createFund({
      fund: {
        ...values
      }
    });
  };

  pathFunction = (id) => {
    let fundId = this.props.match.params.fundId;
    return `/portfolio/funds/${fundId}/deals/${id}`;
  }
  render() {
    const {
      screen_pref,
      sold_deal_table_screen_pref,
      closed_deal_table_screen_pref,
      fundStore,
      funds,
      match: {
        params: { fundId }
      },
      metricData
    } = this.props;
    if (isEmpty(fundStore)) return null;
    if (isEmpty(funds)) return null;
    
    const sortedFundsBySortOrder = _.orderBy(funds, [(obj) => {return obj.sortOrder || ''}], 'desc');
    let fund = fundStore[fundId];

    if(fund && fund.isAuthorized !== undefined && !fund.isAuthorized) {
      this.props.history.push('/AccessDenied');
    }    
    return (
      <Fragment>
        <Styles>
          <div className="detailTabs_header actions">
            <AppBar
              position="static"
              style={{
                backgroundColor: "#fff",
                color: "#606061",
                boxShadow: "none"
              }}
            >
              <Toolbar
                style={{
                  justifyContent: "space-between",
                  minHeight: "34px",
                }}
              >
                <div className="headerItems">
                  <h3 style={{ margin: 0 }}>
                    <Link to={"/portfolio"}>Portfolio</Link> / Groups
                  </h3>
                </div>
              </Toolbar>
            </AppBar>
          </div>
          <ScrollableTabButtons
            funds={sortedFundsBySortOrder}
            fundId={fundId}
            allFunds={this.props.allFunds}
            onChange={(event, value) => this.navigateToFund(value)}
            onAdd={(values)=>{this.createFund(values);this.props.fetchFunds();}}
          />

          <PaddedDiv>

            <MetricPaddedDiv>
              <MetricTile
                screenType={screenType}
                tileData={screen_pref}
                metricData={metricData}
              />
            </MetricPaddedDiv>

            {this.state.view === "list" ? (
              <div>
                <DealList
                  TableScreenElements={ClosedDealTableColumns}
                  screenType={closed_deal_tableScreenType}
                  screenPreferenceList={closed_deal_table_screen_pref}
                  pathFunction={this.pathFunction}
                  funds={{ id: fundId }}
                  status={[CLOSED,REFINANCE, ADDING_SUPPLEMENTAL, MODIFYING]}
                />                
                <DealList
                  TableScreenElements={SoldDealViewTableColumns}
                  screenType={sold_deal_tableScreenType}
                  screenPreferenceList={sold_deal_table_screen_pref}
                  pathFunction={this.pathFunction}
                  funds={{ id: fundId }}
                  status={[SOLD]}
                />
                <Divider />
              </div>
            ) : null}
            {this.state.view !== "list" ? (
              <div>
                <DealTiles
                  screenType={closed_deal_tableScreenType}
                  funds={{ id: fundId }}
                  status={[CLOSED,REFINANCE, ADDING_SUPPLEMENTAL]}
                  openNotes={this.props.openNotes}
                />                
                <DealTiles
                  screenType={sold_deal_tableScreenType}
                  funds={{ id: fundId }}
                  status={[SOLD]}
                  openNotes={this.props.openNotes}
                />
                <Divider />
              </div>
            ) : null}
            <Button
              className="button_tableGridChanger _List"
              onClick={this.listView}
            >
              <FormatListBulletedIcon />
            </Button>
            <Button
              className="button_tableGridChanger _Block"
              onClick={this.tileView}
            >
              <ViewModuleIcon />
            </Button>
          </PaddedDiv>
          
          <PrivateRoute systemAdmin companyAdmin user authentication={this.props.authentication} path={ROUTE_FUNDS_EDIT} Component={routeProps => ( <FundEditModal fund={fund} {...routeProps} onUpdate={this.onFundEdit} /> )} />
        </Styles>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ authentication,  fund, screenPreferences, metricData }) => ({
  authentication, 
  fundStore: fund.fundInfos,
  funds: fund.funds,
  allFunds: fund.all,
  metricData: fund.metricData,
  screen_pref: screenPreferences.screen_pref.fund_view_metric || null,
  sold_deal_table_screen_pref:
    screenPreferences.screen_pref.sold_deal_table || null,
  closed_deal_table_screen_pref:
    screenPreferences.screen_pref.closed_deal_table || null
});

export default connect(
  mapStateToProps,
  {
    createFund,
    fetchAllFunds,
    fetchFunds,
    getFundInfo,
    openNotes,    
    fetchFundDeals,
    getScreenPreferences,
    getFundMetrics
  }
)(FundDealsList);
